// CacheKey eb184bc5716e9663409c35e7c0f84489
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  en: {
    blankslate: {
      defaults: {
        empty: {
          summary: "There are no {{item}}.",
          message: "This care provider does not have any {{item}}."
        },
        error: {
          icon: "error",
          summary: "An error has occurred.",
          message: "Please try again, or contact support@cipherhealth.com if the problem persists."
        }
      },
      view_enrollment: {
        empty: {
          message: "This care provider does not have any <b>active</b> {{item}}.<br/>You can activate or add new {{item}} in the management workflows section."
        }
      }
    },
    filters: {
      arrival: {
        label: "Arrival",
        title: "Filter by arrival date"
      },
      discharge: {
        label: "Discharge",
        title: "Filter by discharge date"
      },
      captain: {
        label: "Captain",
        title: "Filter by captain name"
      },
      captain_name: {
        label: "Captain",
        title: "Filter by captain name"
      },
      encounter: {
        label: "Encounter",
        title: "Filter by encounter id"
      },
      facility: {
        label: "Facility",
        title: "Filter by facility"
      },
      gender: {
        label: "Gender",
        title: "filter by gender"
      },
      icd_code: {
        label: "ICD Code",
        title: "Filter by ICD Code"
      },
      member_id: {
        label: "Member ID",
        title: "Filter by member ID"
      },
      mrn: {
        label: "MRN"
      },
      patient: {
        label: "Patient",
        title: "Filter by patient"
      },
      patient_tags: {
        label: "Patient Tags",
        title: "Filter by patient tags"
      },
      plan: {
        label: "Workflow",
        title: "Filter by workflow"
      },
      reason_for_unenrollment: {
        label: "Reason",
        title: "Filter by reason"
      },
      referral: {
        label: "Referral ID",
        title: "Filter by referral id"
      },
      subscriber_id: {
        label: "Subscriber ID",
        title: "Filter by subscriber ID"
      },
      tags: {
        label: "Tags",
        title: "Filter by patient tags"
      }
    },
    sort: {
      defaults: {
        options: {
          last_rounded_at: "Time of Last Round"
        }
      }
    },
    search: {
      defaults: {
        items: "items",
        empty: {
          icon: "search",
          summary: "There are no {{item}}.",
          message: "As {{item}} are created, they will appear here in a searchable list.",
          pageSummary: "No {{item}} on the current page.",
          pageMessage: "Go back to the previous page, or try a new search query.",
          searchSummary: "We could not find any {{item}}.",
          searchMessage: "Use the links above to find what you are looking for, or try a new search query."
        },
        errors: {
          icon: "error",
          summary: "An error has occurred.",
          message: "Please try again, or contact support@cipherhealth.com if the problem persists."
        },
        toolbar: {
          icon: "search"
        },
        filters: {
          captain: {
            name: "Captain Name"
          },
          encounter: {
            encounter_id: "Encounter ID",
            unit_id: "Unit"
          },
          location: {
            last_rounded_at: "Time of Last Round"
          },
          patient: {
            name: "Patient Name"
          },
          program: {
            name: "Program"
          },
          referral: {
            referral_id: "Referral ID"
          },
          outreach_action: {
            name: "Outreach Action"
          },
          staff_member: {
            last_rounded_on: "Time of Last Round",
            reports_to_staff_member_ids: "Reports To",
            staff_department_id: "Department"
          },
          workflow: {
            name: "Workflow"
          }
        }
      },
      call_history: {
        items: "calls",
        empty: {
          message: "As calls are made for this program, they will appear here in a searchable list.",
          summary: "There are no calls in the last ten days."
        }
      },
      care_team_users: {
        items: "users",
        empty: {
          icon: "user",
          summary: "No team members.",
          message: "As {{item}} are selected, they will be added to the care team."
        }
      },
      closed_tasks: {
        empty: {
          summary: "No closed {{item}}.",
          message: "You don't have any closed {{item}} from your teams.",
          searchSummary: "We could not find any {{item}}.",
          searchMessage: "We only show recently closed {{item}}.<br/>Use the links above to find what you are looking for, or try a new search query."
        }
      },
      enrollment_enroller: {
        empty: {
          summary: "There are no membership rules.",
          message: "As membership rules are created, they will appear here in a searchable list.",
          searchSummary: "We could not find any membership rules."
        }
      },
      criteria: {
        empty: {
          summary: "No criteria defined.",
          message: "As criteria rules are added, they will be displayed here."
        }
      },
      facilitys: {
        empty: {
          summary: "There are no facilities.",
          message: "As facilities are created, they will appear here in a searchable list.",
          searchSummary: "We could not find any facilities."
        }
      },
      live_transfer: {
        empty: {
          icon: "call",
          searchSummary: "No transfer phones.",
          searchMessage: "Once transfer phones are configured for an outreach program, they will appear here allowing to enable/disable them."
        }
      },
      patient_list: {
        empty: {
          summary: "There are no {{item}} with a matching tag.",
          message: "Assign the appropriate tag to {{item}} and they will appear here in a searchable list.",
          searchSummary: "We could not find any {{item}}."
        }
      },
      patient_rounds: {
        items: "patients"
      },
      patients_modal: {
        items: "patients"
      },
      patient_tasks: {
        empty: {
          summary: "No upcoming {{item}}.",
          message: "There are no {{item}} for this patient due in the next seven days."
        }
      },
      overdue_tasks: {
        empty: {
          summary: "No overdue {{item}}.",
          message: "Try clearing your filters or selecting another day."
        }
      },
      pending_tasks: {
        empty: {
          summary: "No pending {{item}}.",
          message: "You don't have any pending {{item}} assigned.<br/>As {{item}} are assigned to you, they will appear here as a searchable and filterable list."
        }
      },
      my_report_subscriptions: {
        empty: {
          summary: "You are not subscribed to any report packages.",
          message: "Reports shown here include your email in the recipients list."
        }
      },
      report_package_scheduler: {
        reports: {
          empty: {
            icon: "document",
            summary: "No reports selected.",
            message: "Select the reports you want to include in this package."
          }
        },
        filetree: {
          errors: {
            icon: "error",
            summary: "Error fetching reports",
            message: "There was an error loading the report file tree, click here to try again."
          }
        },
        parameters: {
          errors: {
            summary: "Error fetching parameters",
            message: "There was an error loading the report parameters, click here to try again."
          },
          empty: {
            icon: "document",
            summary: "No report selected",
            message: "Select a report to configure its parameters."
          }
        }
      },
      rounding_scripts_archived: {
        empty: {
          summary: "There are no archived rounding scripts.",
          message: "As scripts are archived, they will appear here in a searchable list.",
          searchMessage: "There are no archived rounding scripts that match your search terms.<br/>Use the filters to try a new search query."
        }
      },
      rounding_scripts_library: {
        empty: {
          summary: "There are no rounding scripts in the library.",
          message: "As scripts are added to the library, they will appear here in a searchable list.",
          searchMessage: "There are no rounding scripts in the library that match your search terms.<br/>Use the filters to try a new search query."
        }
      },
      user_notifications: {
        empty: {
          icon: "notifications",
          summary: "All caught up!",
          message: "You have no unread notifications."
        }
      },
      widgets: {
        empty: {
          summary: "No widgets for this dashboard",
          message: "Add a widget to this dashboard and configure the title, type, chart type, and interval to get started."
        }
      },
      call_hours: {
        empty: {
          icon: "calendar",
          summary: "No {{item}} for this day",
          message: "Set up outreach hours for a facility-specific outreach time from the custom outreach hours section. For non-facility specific outreach use the custom outreach hours and do not specify a facility."
        }
      },
      import_summary: {
        empty: {
          icon: "waiting",
          summary: "Import is still in progress.",
          message: "Feel free to close this page and come back later."
        }
      },
      archived_actions: {
        empty: {
          summary: "No {{item}} for this program",
          message: "As they are archived, actions for this program will be displayed here."
        }
      },
      activation_criteria: {
        empty: {
          summary: "No {{item}} configured",
          message: "There are no activation criteria rules set for this program."
        }
      },
      echo_instructions: {
        item: "echo instruction",
        empty: {
          summary: "No {{item}} available",
          message: "There are no echo instructions to display at this moment. Try reloading the page if you are expecting any updates."
        }
      },
      enrollment_count_limit: {
        empty: {
          summary: "No {{item}} configured",
          message: "There are no enrollment count limits set for this program."
        }
      },
      export_attempts_admin_panel: {
        empty: {
          summary: "There are no ongoing exports at the moment.",
          message: "As exports are scheduled, they will appear here in a searchable list."
        }
      },
      outreach_actions: {
        empty: {
          summary: "No {{item}} configured",
          message: "There are no {{item}} set for this program."
        }
      },
      hl7_exports: {
        items: "HL7 outbound messages",
        filters: {
          hl7_export: {
            control_id: "Control Id"
          }
        }
      },
      hl7_imports: {
        items: "HL7 imports",
        filters: {
          hl7_import: {
            control_id: "Control Id"
          }
        }
      },
      outbound_message_settings: {
        items: "Outbound message settings"
      },
      hl7_outbound_association: {
        empty: {
          summary: "Message is configured to use standard mappings.",
          message: "Please select <i>\"Use Custom Mappings\"</i> if you want to start using custom mappings for this message."
        }
      },
      map_values: {
        empty: {
          summary: "No mapped values configured",
          message: "There are no mapped values set for this converter."
        }
      },
      change_log: {
        empty: {
          summary: "Coming Soon!",
          message: "This feature hasn't been developed yet."
        }
      }
    }
  }
}

